export { mapTableQueryToTableViewOptions } from './mapTableQueryToTableViewOptions';
//# sourceMappingURL=index.js.map